import * as Styles from "./styles";
import { ReactComponent as NewTaskIcon } from "./icons/new-task.svg";
import { ReactComponent as ScanIcon } from "./icons/scan.svg";
import { Button, Input, message, Select } from "antd";
import type { RefSelectProps } from "antd";
import { PickItem } from "../../../../../../common/models/PickItem";
import { formatDistance } from "date-fns";
import { useEffect, useState, useRef, useMemo } from "react";
import { ReactComponent as CardLoaderIcon } from "../../../../../../assets/icons/card_loader.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Toast } from "./icons/info.svg";
import SkuBin from "../sku-bin/SkuBin";

const barcodeURL: any = process.env.REACT_APP_BARCODE_URL;
const barcodeFormat: any = process.env.REACT_APP_BARCODE_FORMAT;

export interface NewOrderProps {
  pickItemsData: any[];
  PickItemLoading: boolean;
  taskCount: any;
  pickStationsData: any[];
  inwardStationsData?: any[];
  configName?: string;
}

export default function NewOrder({
  pickItemsData,
  PickItemLoading,
  taskCount,
  pickStationsData,
  inwardStationsData = [],
  configName = ""
}: NewOrderProps) {
  const RefSelectProps = useRef<RefSelectProps>(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [startLoading, setStartLoading] = useState(false);
  const [stationFirstData, setStationFirstData] = useState<string[]>([]);
  const [stationSecondData, setStationSecondData] = useState<string[]>([]);
  const [orderId, setOrderId] = useState("");
  const [orderCodeUri, setOrderCodeUri] = useState("");
  const [dropValue, setDropValues] = useState([]);
  // Always show SkuBin as the landing page (skip scan/select gate)
  const [clickStatus, setClickStatus] = useState(true);
  const [clickData, setClickData] = useState(false);
  const hideShimmer = pickItemsData?.length === 1;
  //const taskCount = pickItemsData?.length;
  const navigate = useNavigate();
  const pickTaskItems = useMemo(
    () =>
      Array.isArray(pickItemsData)
        ? pickItemsData.filter((item: any) => item?.pickTask)
        : [],
    [pickItemsData]
  );

  useEffect(() => {
    if (!Array.isArray(pickStationsData) || pickStationsData.length === 0) {
      setStationFirstData([]);
      setStationSecondData([]);
      return;
    }

    const firstRow: string[] = [];
    const secondRow: string[] = [];

    pickStationsData.forEach((station: any) => {
      if (!Array.isArray(station?.gates)) {
        return;
      }
      station.gates.forEach((gate: any) => {
        const slot = gate?.slot;
        if (
          slot &&
          typeof slot.x === "number" &&
          typeof slot.y === "number" &&
          typeof slot.z === "number"
        ) {
          const { x, y, z } = slot;
          const coord = `${x},${y},${z}`;
          if (z === 2) {
            firstRow.push(coord);
          } else if (z === 1) {
            secondRow.push(coord);
          }
        }
      });
    });

    const uniqueAndSortDesc = (entries: string[]) =>
      Array.from(new Set(entries)).sort((a, b) => {
        const ax = Number(a.split(",")[0]);
        const bx = Number(b.split(",")[0]);
        return bx - ax;
      });

    const sortedFirst = uniqueAndSortDesc(firstRow);
    const sortedSecond = uniqueAndSortDesc(secondRow);
    setStationFirstData(sortedFirst);
    setStationSecondData(sortedSecond);
  }, [pickStationsData]);
  useEffect(() => {
    if (pickTaskItems.length > 0) {
      setOrderCodeUri(pickTaskItems[0].pickTask.orderReferenceId);
      const dropValues: any = pickTaskItems.map((val: any, Index: any) => {
        return {
          ...val,
          value: val.pickTask.orderReferenceId,
        };
      });
      const uniqueObjs:any = [...new Set(dropValues.map((obj: any) => obj.pickTask.orderReferenceId))]
  .map(id => dropValues.find((obj: any) => obj.pickTask.orderReferenceId === id))
      setDropValues(uniqueObjs);
    }
    setTimeout(() => {
      RefSelectProps.current !== null && RefSelectProps.current!.focus();
    }, 500);
  }, [pickTaskItems]);
  const clickStart = (clickedItem: any) => {
    // alert(clickedItem)
    if (clickedItem !== "") {
      
       const isFound = pickTaskItems.some((element) => {
        if (element.pickTask.orderReferenceId === clickedItem) {
          setStartLoading(true);
          const filteredArray:any = pickTaskItems.filter(
            (item: any) => item.pickTask.orderReferenceId === clickedItem
          );
          setClickStatus(true);
          setClickData(filteredArray);
          /* setTimeout(() => {
            setStartLoading(false);
            navigate(`/sku_bin/order_id?:${clickedItem}`, {
              state: {
                  filteredArray:  filteredArray,
                  pickStationsFirstData: stationFirstData,
                  pickStationsSecondData: stationSecondData,
                }
            });
          }, 1000); */
        } else {
          setTimeout(() => {
            messageApi.open({
              type: "error",
              content: "Entered the scan ID does not exist !",
              icon: <Toast />,
              className: "error",
              style: {
                marginTop: "85vh",
              },
            });
          }, 1100);
        }
      }); 
    }
  };

  // Reset clickStatus when all tasks are completed
  useEffect(() => {
    if (pickTaskItems.length === 0 && clickStatus) {
      setClickStatus(false);
      setClickData(false);
      setStartLoading(false);
    }
  }, [pickTaskItems, clickStatus]);

  const sortedPickItem = pickTaskItems.slice().sort((a, b) => {
    if (a.creationDate < b.creationDate) {
      return 1;
    }
    if (a.creationDate > b.creationDate) {
      return -1;
    }
    return 0;
  });

  const dateTimeFormat = (time: string) => {
    const distance = formatDistance(Date.now(), new Date(time), {
      addSuffix: true,
    });
    const firstWord = distance.replace(/in/g, "");
    const finalWord = firstWord.replace(/about/g, "");
    const formatted = finalWord.replace(/mutes/g, "Mins");
    const one = formatted.replace(/mute/g, "Minute");
    const two = one.replace(/ago/g, "");
    return two;
  };

  const onChange = (value: string) => {
    setOrderId(value);

    //console.log(`selected ${value}`);
  };

  const onSearch = (value: string) => {
    console.log("search:", value);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (
    input: string,
    option: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <SkuBin
      pickItemsData={pickItemsData}
      pickStationsFirstData={stationFirstData}
      pickStationsSecondData={stationSecondData}
    />
  );
}
